export const API_EXTERNAL_ENDPOINT = 'vacaciones-landings'

export const API_INTERNAL_ENDPOINT = 'strapi/vacaciones-landings/list'
